import { RiskType } from "@/api/mutation/useAddRIskMutation";
import RiskMatrixTable from "./matrix-table";

type Props = {
  data: RiskType[];
  open?: (data: RiskType) => void;
  projectId: string;
};

function RiskMatrix(props: Props) {
  return (
    <div className="mt-10 ml-5 h-full ">
      {/* {riskData && (
        <ReactMatrix
          tableStyles={{ border: "2px solid transparent" }}
          trTitleStyles={{
            fontSize: "14px",
            border: "none",
            background: "#299D91",
            padding: "0.5rem 0.5rem",
            color: "white",
            fontWeight: 400,
          }}
          thTitleStyles={{
            fontSize: "14px",
            border: "none",
            background: "#299D91",
            padding: "0.5rem 0.5rem",
            color: "white",
            fontWeight: 400,
          }}
          trRowStyles={{ height: "120px",maxHeight:"120px" }}
          tdStyles={{ width: "120px",maxWidth:"120px" }}
          data={riskData}
        />
      )} */}
      <RiskMatrixTable
        key={props.data.length}
        risks={props.data}
        onClick={(data) => {
          props.open ? props.open(data) : "";
        }}
        projectId={props.projectId}
      />
    </div>
  );
}

export default RiskMatrix;
